import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/data/categories';

export default function SeoContent() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            Руководство
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Что такое Yoybuy Spreadsheet и как это работает
          </h2>
        </div>

        <article className="prose-custom space-y-6">
          <div className="flex items-center gap-3 mb-6 text-sm text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i> 8 мин чтения
            </span>
            <span>·</span>
            <span>Обновлено: 05.07.2026</span>
          </div>

          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            <strong>Yoybuy Spreadsheet</strong> — это тщательно отобранные и структурированные таблицы товаров с 
            популярных китайских маркетплейсов: <strong>Taobao</strong>, <strong>Weidian</strong> и <strong>1688</strong>. 
            Каждая таблица содержит проверенные ссылки на товары, актуальные цены, QC-фотографии и подробные 
            описания, которые помогают российским покупателям быстро находить качественные вещи без риска 
            нарваться на подделку или недобросовестного продавца.
          </p>

          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            В отличие от хаотичного поиска на китайских платформах, где интерфейс на китайском языке и 
            тысячи непроверенных продавцов, <strong>Yoybuy Spreadsheet</strong> предоставляет уже 
            отфильтрованные и проверенные позиции. Это экономит часы времени и защищает от распространённых 
            ошибок при заказе из Китая.
          </p>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 my-8">
            <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-4">
              Как использовать Yoybuy Spreadsheet за 3 шага
            </h3>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-bold">1</div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-1">Выберите категорию</h4>
                  <p className="text-sm text-foreground-600">Откройте <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-primary-500 hover:text-primary-600 underline cursor-pointer">Yoybuy Sheet</a> и выберите интересующую категорию: обувь, одежда, аксессуары и другое.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-bold">2</div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-1">Скопируйте ссылку</h4>
                  <p className="text-sm text-foreground-600">Скопируйте ссылку на товар из таблицы и вставьте её в форму заказа вашего агента по доставке.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-bold">3</div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-1">Оформите заказ</h4>
                  <p className="text-sm text-foreground-600">Оформите заказ через вашего агента и получите товар с доставкой в Россию в течение 2-4 недель.</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            <strong>Yoybuy Spreadsheet</strong> обновляется еженедельно, поэтому вы всегда получаете актуальные 
            ссылки на товары, которые есть в наличии. Мы тщательно отслеживаем изменения цен и доступность 
            позиций, чтобы ваши покупки были максимально выгодными и безопасными.
          </p>

          <div className="text-center pt-4">
            <Link
              to="/yoybuy-spreadsheet-guide"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
            >
              Читать полное руководство
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}